import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { AlertService } from 'src/app/services/alert.service';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.scss']
})
export class GraphComponent implements OnInit,AfterViewInit {

  @ViewChild('myCanvas') canvas!: ElementRef;

  constructor(private api:ApiService, public util:UtilService, private alertService: AlertService) {   }
  ngAfterViewInit(): void {
    let gradient = this.canvas.nativeElement.getContext('2d').createLinearGradient(0, 0, 0, 600);

    gradient.addColorStop(0, '#29abe2a6');
    gradient.addColorStop(1, '#ffffff');
    this.lineChartColors = [
        {
            backgroundColor: gradient,
            borderColor: '#29abe2',
        }
    ];

  }

  lineChartData: ChartDataSets[] = [
    { data: [], label: 'Uploads' },
  ];

  //Labels shown on the x-axis
  lineChartLabels: Label[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

  // Define chart options
  lineChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      xAxes: [{
        scaleLabel: {
          display: true,
          labelString: 'Date'
        }
      }],
      yAxes: [{
        scaleLabel: {
          display: true,
          labelString: 'Number of Uploads'
        },
        ticks: {
          beginAtZero: true,
          suggestedMin: 0,
          suggestedMax: 7,
          stepSize: 1,
          precision: 0
        }
      }]
    }
  };

  // Define colors of chart segments
  lineChartColors: Color[] = [
    {
      backgroundColor: '#29abe247',
      borderColor: '#29abe2',
    }
  ];

    
  

  createDates(res: any) {
    const { domainValues } = res;
    const now = new Date();

    return [...Array(now.getDate() + 1).keys()].filter(d => {
      return !domainValues.includes(d);
    });
  }

  createValues(res: any) {
    const dates = this.createDates(res).slice(1);
    let vals: any = [];

    dates.map(d => {
      vals.push({
        date: d,
        value: 0,
      });
    });

    return vals.sort((a: any, b: any) => {
      let aDate = a.date;
      let bDate = b.date;
      return aDate < bDate ? -1 : aDate > bDate ? 1 : 0;
    });
  }

  ngOnInit(): void {
    this.api.fetchUserActivity().subscribe((res: any) => {
      //{"maxActivity":4,"domainValues":[10,11],"coordinateMap":[[10,4],[11,1]]}

      let dateObjects = [...Array(7)].map((_, i) => {
        const d = new Date()
        d.setDate(d.getDate() - i)
        return d
      }).reverse();

      let labels: any = [];
      let values: any = [];

      let mappedCM:any = {}
      for (let j = 0; j < res.coordinateMap.length; j++){
        mappedCM[res.coordinateMap[j][0]] = res.coordinateMap[j][1];
      }

      for (let i = 0; i < dateObjects.length; i++) {
        const dateObj = dateObjects[i];
        const day = dateObj.getDate();
        const month = dateObj.toLocaleString('default', { month: 'short' });
        labels[i] = `${month} ${day}`;
        values[i] = mappedCM[day]?mappedCM[day]:0;
      }
      this.lineChartLabels = labels;

      this.lineChartData = [
        { data: values, label: 'Uploads' },
      ];
    }, error=>{
      console.log("error",error);
      this.alertService.toast('Failed to load user activity. Please try again later.');
    });
  }

}
